import {Avatar, Button, message, Modal, Tabs} from 'antd'
import {course_getTeacherById_Api, course_getTeachers_Api, teacherSchema,} from 'apis'
import {getId} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {TeacherActionTypes} from 'views/AppLocals/Course'
import {CreateTeacherModal, EditTeacherModal,} from 'views/AppLocals/Course/Teacher/TeacherForm'
import {useTeacher} from 'views/AppLocals/Course/Teacher/useTeacher'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {renderTeacherCardItem, renderTeacherTableRow} from '../functions/renderTeacher'
import {RiSearchEyeLine} from "react-icons/ri";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {ItemInformation} from 'components/common/ItemInformation'
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import getAvatar from "../../../../helpers/getAvatar";
import {renderIf, renderIfElse} from "../../../Shared";
import TeacherFilter from "../components/filters/TeacherFilter";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {FaLink, FaUserTie} from "react-icons/fa6";
import {BsGrid3X3GapFill, BsPersonFillCheck, BsPersonFillX, BsTable} from "react-icons/bs";
import {NoImage} from "../../../../conts/imageBase64";
import ImageLoader from "../../../../components/ImageLoader";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {MemberActivityHistory} from 'components/common/MemberActivityHistory'
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getAliasName from "../../../../helpers/getAliasName";
import getTitle from "../../../../helpers/getTitle";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import LoadingBlock from "../../../Loading/LoadingBlock";
import classNames from "classnames";
import WorkspaceContext from "../../WorkspaceContext";
import PagePaginationWrapper from "../../../../modules/asyncCache/components/PagePagination/PagePaginationWrapper";
import {renderLoading} from "../../../AppLocals/functions/renderers/renderLoading";
import EmptyHolder from "../../../../components/EmptyHolder";
import {createConfirmApproveDialog} from "../../../AppLocals/factory/createConfirmDialog";
import copyToClipboard from "copy-to-clipboard";
import {IoCopyOutline} from "react-icons/io5";


const Teachers = ({
                      owner_id, owner_type,
                      Wrapper = 'div',
                      hashtagsFilter = '',
                      filter_actions = {
                          sortBy: 'sort-by',
                          keyword: 'keyword',
                          hashtags: 'hashtags',
                          active: 'active',
                      }
                  }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })
    // Bảng mặc định desktop, Thẻ mặc định mobile - khớp đúng cách đã làm ở Students.js.
    const [viewMode, setViewMode] = useState(() => isLg ? 'table' : 'card')
    const hashtags = useRouteSearchParam(filter_actions.hashtags) || hashtagsFilter;
    const active = useRouteSearchParam(filter_actions.active);

    const onCancel = () => {
        setAction({})
    }

    const {
        refreshKey,
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onActive = NullAsDefault,
        onDisable = NullAsDefault,
        onDelete = NullAsDefault,
    } = useTeacher({
        onCreated: onCancel,
        onUpdated: onCancel,
        onActive: onCancel,
        onDisable: onCancel,
        onDeleted: onCancel,
    })

    const confirmActive = useCallback(
        (id) => {
            if (id) {
                createConfirmApproveDialog({
                    icon: <BsPersonFillCheck style={{color: '#38a169'}} className="anticon"/>,
                    translate: t,
                    title: 'reactive teacher',
                    message: 'reactive teacher description',
                    okText: t('sure'),
                    okButtonProps: {
                        type: 'primary',
                        className: 'no-border rounded-lg font-semibold text-sm px-3',
                    },
                    onOk: () => {
                        onActive({}, {id})
                    },
                    cancelText: t('close'),
                    cancelButtonProps: {
                        type: 'default',
                        className: 'no-shadow no-border rounded-lg bg-transparent font-medium text-color-300',
                    },
                    onCancel: () => {
                        onCancel()
                    },
                })
            }
        },
        [onDisable]
    )

    const confirmDisable = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    icon: <BsPersonFillX className="anticon"/>,
                    translate: t,
                    title: 'temporarily inactive teacher',
                    message: 'temporarily inactive teacher description',
                    onOk: () => {
                        onDisable({}, {id})
                    },
                })
            }
        },
        [onDisable]
    )

    const confirmDelete = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete teacher',
                    message: 'are you sure you want to delete it teacher',
                    onOk: () => {
                        onDelete({}, {id})
                    },
                })
            }
        },
        [onDelete]
    )

    const handleAction = (action, params) => {
        switch (action) {
            case TeacherActionTypes.TEACHER_READ:
            case TeacherActionTypes.TEACHER_UPDATE:
            case TeacherActionTypes.TEACHER_CREATE:
                setAction({type: action, value: params})
                break
            case TeacherActionTypes.TEACHER_ACTIVE:
                confirmActive(params?.id)
                break
            case TeacherActionTypes.TEACHER_DISABLE:
                confirmDisable(params?.id)
                break
            case TeacherActionTypes.TEACHER_DELETE:
                confirmDelete(params?.id)
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) => {
            const {
                course_class_count = 0,
                course_class_coordinator_count = 0,
                course_teachers_count = 0,
            } = item ?? {}
            // Đang được gán ở bất kỳ đâu (Ban điều hành/Người phụ trách lớp/Giảng viên theo thời
            // khóa biểu) thì không cho xóa - khớp đúng guard đã chặn ở BE (deleteTeacher), disable
            // trước ở đây để không cho bấm thay vì để bấm xong mới báo lỗi.
            const isInUse = course_class_count > 0 || course_class_coordinator_count > 0 || course_teachers_count > 0

            return createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-green-600"/>,
                        label: 'view detail',
                        key: TeacherActionTypes.TEACHER_READ,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: TeacherActionTypes.TEACHER_UPDATE,
                    },
                    {
                        icon: <BsPersonFillCheck size={14} className={item?.active === 0 ? 'text-green-500' : 'text-color-500'}/>,
                        label: 'reactivate',
                        key: TeacherActionTypes.TEACHER_ACTIVE,
                        disabled: item?.active === 1,
                    },
                    {
                        icon: <BsPersonFillX size={14} className={item?.active === 1 ? 'text-orange-400' : 'text-color-500' }/>,
                        label: 'temporarily inactive',
                        key: TeacherActionTypes.TEACHER_DISABLE,
                        disabled: item?.active === 0,
                    },
                    {
                        icon: <BiTrash size={14} className={isInUse ? 'text-color-500' : 'text-primary-300'}/>,
                        label: 'delete',
                        key: TeacherActionTypes.TEACHER_DELETE,
                        disabled: isInUse,
                        title: isInUse ? t('cannot delete teacher in use') : undefined,
                    },
                ].filter((e) => item),
                (key) => {
                    if (key === TeacherActionTypes.TEACHER_DELETE && isInUse) return
                    handleAction(key, item)
                }
            )
        },
        [t]
    )

    const DetailTeacherContent = ({item}) => {
        const t = useTranslate()
        const {
            user,
            avatar,
            fullname,
            teacher_idcode,
            date_of_birth,
            prefix_title,
            gender,
            place_of_birth,
            contact_phone,
            contact_email,
            contact_address,
            majors,
            fields,
            experiences,
            degrees,
            hashtags = "",
            edit,
            is_student = false,
            student_courses = [],
            is_teacher_in_courses = false,
            teacher_courses = [],
        } = item ?? {}

        const tags = (hashtags || "").split(",").filter(e => !!e);

        return (
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col">
                        <span className="font-bold text-base text-gray-700 tracking-wide">
                            {t('teacher information')}
                        </span>
                        <div style={{ height: 3 }} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    <div className="flex gap-3">
                        <ImageLoader
                            style={{width: isSm ? 100 : 120, height: isSm ? 140 : 160}}
                            src={avatar || getAvatar(user) || NoImage}
                            fallback={NoImage}
                            className="background-200 rounded-xl object-cover"
                        />
                        <div className="flex flex-col flex-1 gap-1">
                            <span className="font-bold text-lg text-color-000 tracking-wide">
                                {(item?.patron_saint_name || prefix_title) && (
                                    <span className="mr-1 font-medium text-sm text-gray-600">
                                        {item?.patron_saint_name ? item?.patron_saint_name : prefix_title}
                                    </span>
                                )}
                                {fullname}
                            </span>
                            {renderIf(
                                teacher_idcode,
                                <div className="text-xs tracking-wider">
                                    <span className="text-color-400 whitespace-no-wrap">
                                        {isSm ? '#' : `${t('teacher code')} : `}
                                    </span>
                                    <span
                                        onClick={() => {
                                            copyToClipboard(teacher_idcode)
                                            message.info(t('copied'))
                                        }}
                                        className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                        {teacher_idcode}
                                        <IoCopyOutline size={12} className="ml-1"/>
                                    </span>
                                </div>
                            )}
                            {renderIf(
                                gender !== 0,
                                <ItemInformation showIcon={true} label={!isSm && "gender"} value={t(getLabelOfGender(gender))} className="text-xs tracking-wider"/>
                            )}
                            {renderIf(
                                _.some([date_of_birth, place_of_birth]),
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst={!isSm && "date of birth"}
                                    valueFirst={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                    labelSecond={place_of_birth ? ' - ' : ''}
                                    valueSecond={place_of_birth}
                                    className="text-xs tracking-wider"
                                />
                            )}
                            {renderIf(
                                tags.length > 0,
                                <div className="flex flex-wrap gap-2 mt-1 md:mt-2">
                                    {tags.map((ee, ii) => (
                                        <span
                                            key={ii}
                                            style={{
                                                width: 'fit',
                                                height: isSm ? 17 : 20,
                                                padding: isSm ? '0 8px' : '1px 8px',
                                                fontSize: isSm ? 9 : 11,
                                                borderRadius: 999
                                            }}
                                            className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                            {ee}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {renderIf(
                        user,
                        <div className="flex flex-col gap-1">
                            <span className="font-medium text-xs text-color-300 italic">
                                <FaLink size={10} className="mr-1 text-color-300"/>
                                {`${t('link account')} : `}
                            </span>
                            <div className="ml-2 flex items-center gap-3">
                                <Avatar
                                    size={32}
                                    src={getAvatar(user)}
                                    icon={<FaUserTie size={18} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                {renderIfElse(
                                    edit === true,
                                    <Link target="_blank" to={getLinkToDetail(user)} className="font-bold text-gray-700 tracking-wide no-underline leading-snug">
                                        {getAliasName(user, 'patron_saint')}
                                        {` ${getTitle(user)}`}
                                    </Link>,
                                    <span className="font-bold text-gray-700 tracking-wide leading-snug">
                                        {getAliasName(user, 'patron_saint')}
                                        {getTitle(user)}
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                {renderIf(
                    _.some([majors, fields, experiences, degrees]),
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-col">
                            <span className="font-semibold text-sm text-gray-700 tracking-wide">
                                {t('education level')}
                            </span>
                            <div style={{ height: 3 }} className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                        </div>
                        <div className="ml-0 md:ml-1 flex flex-col gap-1">
                            <ItemInformation showIcon={true} label="degrees" value={degrees}
                                             className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="experiences" value={experiences}
                                             className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="fields" value={fields} className="text-xs italic"/>
                            <ItemInformation showIcon={true} label="majors" value={majors} className="text-xs italic"/>
                        </div>
                    </div>
                )}
                <Tabs
                    defaultActiveKey="contact"
                    size="small"
                    tabBarStyle={{margin: '0 0 12px 0'}}
                    items={[
                        {
                            key: 'contact',
                            label: t('contact information'),
                            children: (
                                <div className="ml-0 md:ml-1 flex flex-col gap-1">
                                    <ItemInformation showIcon={true} label="phone" value={contact_phone}
                                                     className="text-xs italic"/>
                                    <ItemInformation showIcon={true} label="email" value={contact_email}
                                                     className="text-xs italic"/>
                                    <ItemInformation showIcon={true} label="address" value={contact_address}
                                                     className="text-xs italic"/>
                                </div>
                            ),
                        },
                        ...(is_student || is_teacher_in_courses ? [{
                            key: 'activity',
                            label: t('activity history'),
                            children: (
                                <div className="pr-1">
                                    <MemberActivityHistory
                                        is_student={is_student}
                                        student_courses={student_courses}
                                        is_teacher={is_teacher_in_courses}
                                        teacher_courses={teacher_courses}
                                    />
                                </div>
                            ),
                        }] : []),
                    ]}
                />
                <div className="p-3 text-right">
                    <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                        {t('close')}
                    </span>
                </div>
            </div>
        )
    }

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {fullname: undefined}
        let modal_params = {}
        switch (action?.type) {
            case TeacherActionTypes.TEACHER_READ:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('view teacher information')}
                    </div>
                )
                modal_params = {
                    width: 640,
                }
                Content = ({initialValues}) => <DetailTeacherContent item={initialValues}/>
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: course_getTeacherById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            case TeacherActionTypes.TEACHER_CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create teacher')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values, {
                            id: owner_id,
                            type: owner_type,
                        })
                    },
                }
                modal_params = {
                    width: 720,
                }
                Content = CreateTeacherModal
                break
            case TeacherActionTypes.TEACHER_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update teacher')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                modal_params = {
                    width: 800,
                }
                Content = ({initialValues, ...rest}) => (
                    <SelectEntityItem
                        schema={teacherSchema}
                        item={getId(initialValues)}
                        defaultItem={initialValues}>
                        {(item) => (
                            <EditTeacherModal
                                {...rest}
                                initialValues={item}
                            />
                        )}
                    </SelectEntityItem>
                )
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: course_getTeacherById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            hashtags,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, hashtags, refreshKey, location.state]
    )

    const {organization} = useContext(WorkspaceContext)
    const stats = organization?.workspace_settings?.courses?.statistics ?? {}

    // Bảng: cột GIẢNG VIÊN (gộp giới tính + ngày sinh) | MÃ GIẢNG VIÊN | TÀI KHOẢN USER |
    // NGHỀ NGHIỆP & HỌC VỊ | THÔNG TIN LIÊN HỆ | THAO TÁC - dùng chung cho <thead>, khớp cột
    // với renderTeacherTableRow (renderTeacher.js).
    const TABLE_COLUMNS = [
        {label: t('teacher'), className: 'text-left'},
        {label: t('teacher code'), className: 'text-left'},
        {label: t('user account'), className: 'text-left'},
        {label: `${t('occupation')} & ${t('degrees')}`, className: 'text-left'},
        {label: t('contact'), className: 'text-left'},
        {label: t('actions'), className: 'text-right'},
    ]

    const teacherHandleAction = (type, value) => {
        setAction({type, value});
    }

    const renderList = useCallback(
        ({keyword, sortBy: currentSort, filterBy, refreshKey}) => (
            <PagePaginationWrapper
                apiInfo={course_getTeachers_Api}
                query={bindQueryParams([{id: owner_id}, {type: owner_type}])}
                values={{...filter_actions, keyword, sort_by: currentSort, ...(filterBy ?? {})}}
                refreshKey={refreshKey}
                renderItem={
                    viewMode === 'table'
                        ? renderTeacherTableRow({translate: t, renderContextMenu, handleAction: teacherHandleAction})
                        : renderTeacherCardItem({translate: t, renderContextMenu, handleAction: teacherHandleAction})
                }
                renderLoading={() => renderLoading()}
                renderEmpty={() => <EmptyHolder/>}
                Wrapper={({children}) => viewMode === 'table' ? (
                    <div className="mt-2 w-full overflow-x-auto rounded-xl border border-color-50">
                        <table className="w-full" style={{borderCollapse: 'collapse'}}>
                            <thead>
                                <tr className="background-200">
                                    {TABLE_COLUMNS.map((col, i) => (
                                        <th key={i} className={classNames("px-3 py-2 text-2xs font-bold text-color-400 uppercase tracking-wider whitespace-no-wrap", col.className)}>
                                            {col.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>{children}</tbody>
                        </table>
                    </div>
                ) : (
                    <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {children}
                    </div>
                )}
            />
        ),
        [owner_id, owner_type, t, renderContextMenu, viewMode, filter_actions]
    )

    const viewModeToggle = (
        <div className="flex items-center flex-shrink-0 rounded-lg border border-color-200 overflow-hidden">
            <button
                type="button"
                title={t('card')}
                onClick={() => setViewMode('card')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors",
                    viewMode === 'card' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsGrid3X3GapFill size={14}/>
            </button>
            <button
                type="button"
                title={t('table')}
                onClick={() => setViewMode('table')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors border-l border-color-200",
                    viewMode === 'table' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsTable size={14}/>
            </button>
        </div>
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id, owner_type
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                hashtags: hashtags,
                active: active,
            })
        },
        renderList,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        // Toggle Thẻ/Bảng đặt cạnh ô search (renderHeader) - không đụng TeacherFilter/search bar,
        // khớp đúng cách đã làm ở Students.js.
        renderHeader: ([search_bar]) => (
            <div className="flex items-center gap-2">
                <div className="flex-1 min-w-0">{search_bar}</div>
                {viewModeToggle}
            </div>
        ),
        query_params: filter_actions,
        isToggleDefault: false,
        AdvancedFilter: TeacherFilter,
        dependencies: [owner_id, owner_type, hashtagsFilter, active],
        withKey: createPagerKey(refresh_deps),
    })
    return (
        <Wrapper className="flex flex-col gap-3">
            <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('teacher staff management')} {`(${stats?.teacher_count} ${t('teacher')})`}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 text-sm text-color-300 tracking-wider">
                        {t('manage teacher profiles assign roles admin lecturer teaching assistant and track teaching performance')}
                    </div>
                </div>
                <Button
                    color="primary" variant="solid"
                    className="px-6 py-2 font-semibold rounded-lg"
                    onClick={() => {
                        handleAction(TeacherActionTypes.TEACHER_CREATE)
                    }}>
                    {t('add new staff')}
                </Button>
            </div>
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </Wrapper>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(Teachers)
